<!--  -->
<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <el-row v-if="statusView=='All'" type="flex"  align="middle" style="margin-top:15px;margin-left:15px;">
        <el-button size="mini" @click="addData" type="primary">新增</el-button>
        <el-button size="mini"  @click="delData" type="danger">删除</el-button>
    </el-row>
    <el-table style="margin-top:15px;" border ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500"  highlight-current-row>
        <el-table-column align="center" type="selection" width="80" />
        <el-table-column align="center" label="版本" min-width="140" prop="headerVersion" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="所属大类" min-width="100" prop="parentName" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="评分项编码" min-width="100" prop="scoreItemCode" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="评分项名称" min-width="120" prop="name" show-overflow-tooltip>
            <template v-slot="scope">
            <el-button type="text" @click="onDetail(scope.row)">{{scope.row.name}}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Description" min-width="120" prop="description" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="SPM" min-width="80" prop="version" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="最大分值" min-width="120" prop="maxValue" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="Wt.1" min-width="120" prop="wt1" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="Wt.2" min-width="120" prop="wt2" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="评分标准说明1" min-width="120" prop="standard1" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="评分标准说明2" min-width="120" prop="standard2" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="评分标准说明3" min-width="120" prop="standard3" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="评分标准说明4" min-width="120" prop="standard4" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="评分标准说明5" min-width="120" prop="standard5" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="排序" min-width="120" prop="orderNo" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="更新人" min-width="120" prop="updateByName" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="更新时间" min-width="120" prop="updateDate" show-overflow-tooltip></el-table-column>
    </el-table>

    <el-dialog label="维护评分项" :visible.sync="showDetailDialog" append-to-body width="50%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog" :formData="formData" :temId="temId" @close="closeDialog" :detailId="detailId"></detailDialog>
    </el-dialog>

  </div>
</template>

<script>
import apiService  from "@/api/AAA/index.js";

import detailDialog from '../dialog/maintainScoreInfo.vue'

export default {
  data () {
    return {
        detailId:"",
        showDetailDialog:false,
        temId:this.$route.query.id,
        tableData:[],
        multipleSelection:[],
        rulesList:localStorage.getItem('ms_roles'),
        identity:localStorage.getItem('ms_emplFlag'),
        statusView:""
    };
  },

  components: {
      detailDialog
  },
  created(){
    this.getDetailData()
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    if (this.identity=='SUP') {   //判断是供应商
      this.statusView = 'S';
    }else {
      if(this.rulesList.indexOf('QSPI_AAA_OWNER')!=-1||this.rulesList.indexOf('QSPI_AAA_ADMIN')!=-1){
        this.statusView='All'
      }else{
        this.statusView='C'
      }
      // if(this.rulesList.indexOf('QSPI_AAA_CQS')!=-1&&this.rulesList.indexOf('QSPI_AAA_OWNER')!=-1){
      //   this.statusView = 'OC';
      // }else{
      //   for (let i = 0, len = permission.length; i < len; i++) {
      //     if (permission[i] == 'QSPI_AAA_OWNER') {
      //       this.statusView = 'O';
      //       return
      //     }else{
      //       this.statusView = 'C';
      //     }
      //   }
      // }
    }
    console.log("ssssssssssssss",this.statusView)
  },
  computed: {},

  methods: {
    selectionChange(val){
      this.multipleSelection=val
    },
    getDetailData(){
      apiService.getTemDataInfo(this.temId).then((res)=>{
        this.tableData=res.resultData
      })
    },
    delData(){
      if(this.multipleSelection.length==1){
        let params=[]
        this.multipleSelection.forEach((v)=>{
          params.push(v.ttQspiAppraiseTemplateDetailId)
        })
        apiService.deleteTemInfo(params,this.temId).then((res)=>{
          if(res.code==200){
            this.$message.success('删除成功')
            this.getDetailData()
          }else{
            this.$message.error(res.msg)
          }
        })
      }else if(this.multipleSelection.length>1){
        this.$message.error('只能勾选一项')
      }else{
        this.$message.error('请勾选数据')
      }

      
    },
    addData(){
      this.showDetailDialog=true
      this.formData={}
    },
    onDetail(row){
        this.detailId=row.ttQspiAppraiseTemplateDetailId
        apiService.templateDetailInfo(row).then((res)=>{
          this.formData=res.data
          this.showDetailDialog=true
        })
    },
    closeDialog(){
        this.showDetailDialog=false
        this.getDetailData()
    },
    routerBack() {
      let arr=JSON.parse(sessionStorage.getItem("setQuery"))
      this.$store.dispatch('saveQuery',arr)
      this.$router.back();
    },
  }
}

</script>
<style  scoped>
</style>